import { useParams } from "react-router-dom";
import useCoreStore from "views/hooks/useCoreStore";

interface CustomQueryVariablesProps {
  search: string;
  prevOptions: unknown[];
}

export default function useCustomQueryVariables() {
  const urlParams: RouteParams = useParams();
  const companyData = useCoreStore(state => state.companyData);
  const accountingPlanType = companyData?.settings?.accountingPlanType?.value;
  const isSNPlan = accountingPlanType === "SN";

  const customQueryVariables = ({ search, prevOptions }: CustomQueryVariablesProps) => {
    const variables = {
      filter: {
        companyId: urlParams.companyId,
        isActive: true,
        search: search,
        code_Istartswith_In: search ? undefined : isSNPlan ? ["443"] : ["445"],
      },
      limit: 100,
      offset: prevOptions.length,
    };
    return variables;
  };

  return customQueryVariables;
}
